const formatField = (id, value) => {
  const length = String(value.length).padStart(2, '0');
  return `${id}${length}${value}`;
};

const sanitizeMerchantName = (value = '') =>
  value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^A-Za-z0-9 ]/g, '')
    .trim()
    .slice(0, 25)
    .toUpperCase();

const sanitizeMerchantCity = (value = '') =>
  value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^A-Za-z0-9 ]/g, '')
    .trim()
    .slice(0, 15)
    .toUpperCase();

const crc16 = (value) => {
  let crc = 0xffff;

  for (let index = 0; index < value.length; index += 1) {
    crc ^= value.charCodeAt(index) << 8;
    for (let bit = 0; bit < 8; bit += 1) {
      if (crc & 0x8000) {
        crc = (crc << 1) ^ 0x1021;
      } else {
        crc <<= 1;
      }
      crc &= 0xffff;
    }
  }

  return crc.toString(16).toUpperCase().padStart(4, '0');
};

const buildPixCopyPasteCode = ({
  amount,
  city,
  key,
  merchantName,
  txid = 'APOIOEXTRATOR'
}) => {
  const normalizedKey = (key || '').trim();
  const normalizedName = sanitizeMerchantName(merchantName || 'Monitor Fiscal');
  const normalizedCity = sanitizeMerchantCity(city || 'SAO PAULO');
  const normalizedTxid = String(txid).replace(/[^A-Za-z0-9]/g, '').slice(0, 25) || 'APOIOEXTRATOR';

  const merchantAccountInfo = formatField(
    '26',
    [
      formatField('00', 'br.gov.bcb.pix'),
      formatField('01', normalizedKey)
    ].join('')
  );

  const amountField = amount ? formatField('54', Number(amount).toFixed(2)) : '';
  const additionalDataField = formatField('62', formatField('05', normalizedTxid));

  const payloadWithoutCrc = [
    formatField('00', '01'),
    formatField('01', '11'),
    merchantAccountInfo,
    formatField('52', '0000'),
    formatField('53', '986'),
    amountField,
    formatField('58', 'BR'),
    formatField('59', normalizedName),
    formatField('60', normalizedCity),
    additionalDataField,
    '6304'
  ].join('');

  return `${payloadWithoutCrc}${crc16(payloadWithoutCrc)}`;
};

export { buildPixCopyPasteCode };
